module.exports = __webpack_public_path__ + "img/23.3faaaf1c.jpg";